import { Copy, t } from '@stokr/components-library'
import { downloadChartCsv } from 'components/ui/chart'
import type { HistoryColumn } from 'models/productChart'
import { InlineAction } from './Performance.styles'
import { useStoTrack } from 'hooks/sto/useStoTracking'

/** Saves the full history, every denomination side by side: the table behind the chart. */
const downloadHistory = (history: HistoryColumn[], symbol: string) =>
  downloadChartCsv(
    history.map(({ currency, headerKey, points }) => ({ header: t(headerKey, { currency }), points })),
    `${symbol || 'STOKR'} - price history`,
  )

/** "Download CSV" inside a chart footnote. */
export const DownloadCsv = ({ history, symbol }: { history: HistoryColumn[]; symbol: string }) => {
  const trackSto = useStoTrack()
  return (
    <InlineAction
      type="button"
      data-cy="sto-performance-download-csv"
      onClick={() => {
        trackSto('sto_chart_csv_downloaded', { chart: 'performance' })
        downloadHistory(history, symbol)
      }}>
      <Copy id="stoPage.performance.downloadCsv" />
    </InlineAction>
  )
}
